import { fetchUtil } from "./fetchUtil";
import { appendQueryParams } from "./urlUtils";
import useAuthStore from "../store/Auth";

interface RequestOptions {
  baseUrl?: string;
  noBaseUrl?: boolean;
  url?: string;
  params?: Record<string, any>;
  isAuthorized?: boolean;
  abortSignal?: AbortSignal | null;
  body?: Record<string, any>;
  isFormData?: boolean;
  isParamsNotEncoded?: boolean;
  isFormUrlEncoded?: boolean;
  isCredentialInclude?: boolean;
  isReturnBlob?: boolean;
}

export const Get = async ({
  noBaseUrl = false,
  url = "",
  params = {},
  isAuthorized = true,
  abortSignal = null,
  isReturnBlob = false,
}: RequestOptions) => {
  let token = null;
  if (isAuthorized) {
    token = useAuthStore.getState().token;
  }

  return fetchUtil({
    noBaseUrl,
    url: Object.keys(params).length > 0 ? appendQueryParams(url, params) : url,
    token,
    abortSignal,
    isReturnBlob,
  })
    .then((res) => {
      const { result } = res;
      return Promise.resolve(result ? result : res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const Post = async ({
  baseUrl,
  url = "",
  body = {},
  params = {},
  isAuthorized = true,
  abortSignal = null,
  isFormData = false,
  isFormUrlEncoded = false,
  isCredentialInclude = false,
  isReturnBlob = false,
}: RequestOptions) => {
  let token = null;
  if (isAuthorized) {
    token = useAuthStore.getState().token;
  }

  const formUrlEncodedBody =
    isFormUrlEncoded && new URLSearchParams(body).toString();

  return fetchUtil({
    baseUrl,
    url: Object.keys(params).length > 0 ? appendQueryParams(url, params) : url,
    token,
    body:
      isFormData && !isFormUrlEncoded
        ? (body as any)
        : isFormData && isFormUrlEncoded
        ? (formUrlEncodedBody as any)
        : JSON.stringify(body),
    method: "POST",
    abortSignal,
    isFormData,
    isFormUrlEncoded,
    credentials: isCredentialInclude ? "include" : "same-origin",
    isReturnBlob,
  })
    .then((res) => {
      const { result } = res;
      return Promise.resolve(result ? result : res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const Put = async ({
  url = "",
  params = {},
  body = {},
  isAuthorized = true,
  abortSignal = null,
  isParamsNotEncoded = false,
}: RequestOptions) => {
  let token = null;

  if (isAuthorized) {
    token = useAuthStore.getState().token;
  }

  return fetchUtil({
    url:
      Object.keys(params).length > 0
        ? appendQueryParams(url, params, isParamsNotEncoded)
        : url,
    token,
    body: JSON.stringify(body),
    method: "PUT",
    abortSignal,
  })
    .then((res) => {
      const { data } = res;
      return Promise.resolve(data ? data : res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const Delete = async ({
  url = "",
  isAuthorized = true,
  abortSignal = null,
  body = {},
  params = {},
}: RequestOptions) => {
  let token = null;

  if (isAuthorized) {
    token = useAuthStore.getState().token;
  }

  return fetchUtil({
    url: Object.keys(params).length > 0 ? appendQueryParams(url, params) : url,
    token,
    method: "DELETE",
    abortSignal,
    body: JSON.stringify(body),
  })
    .then((res) => {
      const { data } = res;
      return Promise.resolve(data ? data : res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const Patch = async ({
  url = "",
  body = {},
  isAuthorized = true,
  abortSignal = null,
}: RequestOptions) => {
  let token = null;

  if (isAuthorized) {
    token = useAuthStore.getState().token;
  }

  return fetchUtil({
    url,
    token,
    body: JSON.stringify(body),
    method: "PATCH",
    abortSignal,
  })
    .then((res) => {
      const { data } = res;
      return Promise.resolve(data ? data : res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
